import angular from 'angular';
import groupMembersTemplate from './groupMembers.html';
import CSMCommonWeb from 'csm-common-web';
// 'ui.grid.edit' and 'ui.grid.selection' modules are imported with uiGrid when it runs;

export default angular
  .module('csm.books.com.groupMembers', [
    CSMCommonWeb,
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.cellNav'
  ])
  .component('groupMembers', Component()).name;

/*******************************************************************************
 * Component */
/**
 * @ngdoc  component
 * @module csm.books.com.groupMembers
 * @name   csm.books.com.groupMembers.component:groupMembers
 *
 * @param {array}  entities   Source list of potential members
 * @param {array}  members    Current list of members
 * @param {string} hideTitle  Hide the title column for management
 * @description
 * This component allows for the management of group members from the provided
 * source list of entitites to the managed list of members. If hideTitle is false,
 * a member title can be managed as well.
 *******************************************************************************/
/* @ngInject */ function Component() {
  return {
    controller: Controller,
    template: groupMembersTemplate,
    bindings: {
      entities: '<',
      members: '='
    }
  };
}

/*******************************************************************************
 * Controller */
/**
 * @ngdoc  controller
 * @module csm.books.com.groupMembers
 * @name   csm.books.com.groupMembers.controller:groupMembersController
 * @description
 * Controller for the groupMembers component
 *******************************************************************************/
/* @ngInject */ function Controller($injector, $element, $scope) {
  var $ctrl = this;
  $ctrl.dgMembers = $injector.invoke(initDG, null, {
    $ctrl: $ctrl,
    $element: $element
  });

  var $utils = {};
  $utils.deleteMember = $injector.invoke(deleteMember, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $utils.refreshNonMembers = $injector.invoke(refreshNonMembers, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });

  $ctrl.handleAdd = $injector.invoke(handleAdd, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $ctrl.$onInit = $injector.invoke($onInit, null, {
    $ctrl: $ctrl,
    $scope: $scope,
    $utils: $utils
  });
  $ctrl.onNewMember = $injector.invoke(onNewMember, null, { $ctrl: $ctrl });
}

/***************************************************************************
 * deleteMember */
/**
 * Remove the entity from the members list and updates the non members
 * dataprovider. Called when the delete icon is clicked in the grid.
 *
 * @param  member  Entity to remove from the grid.
 ***************************************************************************/
/* @ngInject */ function deleteMember($ctrl, $utils) {
  return function (member) {
    var index = $ctrl.members.indexOf(member);
    $ctrl.members.splice(index, 1);
    $utils.refreshNonMembers();
  };
}

/***************************************************************************
 * handleAdd */
/**
 * Handles the adding of a new member to the members grid. This is called on
 * enter from the lazyTypeahead or the Add button.
 ***************************************************************************/
/* @ngInject */ function handleAdd(Alert, $ctrl, $utils) {
  return function () {
    /*----------------------------------*/
    /* No entity selected to add. Exit. */
    /*----------------------------------*/
    if (!$ctrl.newMember || typeof $ctrl.newMember != 'object') {
      Alert.error(' ', 'No individual selected');
      $ctrl.inputHasFocus = true;
      return;
    }

    /*------------------------------------------------------------------*/
    /* Add a copy of the selected entity to the grid. This is so the    */
    /* title field can be modified without updating the original entity */
    /*------------------------------------------------------------------*/
    $ctrl.members.push(angular.extend({}, $ctrl.newMember));

    /*-----------------------------------------------*/
    /* Clear New Member input field set focus on it. */
    /*-----------------------------------------------*/
    $ctrl.newMember = null;
    $ctrl.inputHasFocus = true;

    /*------------------------------------------*/
    /* Update the list of available nonmembers. */
    /*------------------------------------------*/
    $utils.refreshNonMembers();
  };
}

/***************************************************************************
 * initDG */
/**
 * Generate the uiGrid options object for managing member records. This will
 * check for the hide-title attribute to determine the Title column will be
 * visible.
 *
 * @return uiGrid options object
 ***************************************************************************/
/* @ngInject */ function initDG(
  uiGridConstants,
  CommonUIGridTemplates,
  $element
) {
  var hideTitleAttr = $element.attr('hide-title');
  var titleVisible =
    hideTitleAttr == undefined || hideTitleAttr.toLowerCase() == 'false';

  return {
    enableColumnMenus: false,
    enableCellEdit: false,
    enableCellEditOnFocus: true,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    minRowsToShow: 6,
    onRegisterApi: function (gridApi) {
      this.api = gridApi;
    },
    data: [],
    columnDefs: [
      {
        field: 'Title',
        editableCellTemplate: CommonUIGridTemplates.CELL_DEFAULT,
        enableCellEdit: true,
        visible: titleVisible,
        width: '30%'
      },
      {
        displayName: 'Student ID',
        field: 'StudentID',
        width: '25%'
      },
      {
        field: 'Name'
      },
      {
        field: 'delete',
        maxWidth: 10,
        cellTemplate: CommonUIGridTemplates.CELL_DELETE_ROW,
        displayName: ' ',
        enableSorting: false
      }
    ]
  };
}

/***************************************************************************
 * $onInit */
/**
 * Called by angular when the component has been initialized. This will
 * normalize the entities binding for varying data sources and set up listeners.
 ***************************************************************************/
/* @ngInject */ function $onInit(CommonUIGridTemplates, $ctrl, $scope, $utils) {
  return function () {
    /*--------------------------------------------------------------------*/
    /* Set the source and filter for nonMembers to be in the format of    */
    /* GroupMember objects.                                               */
    /*                                                                    */
    /* We need to apply a mapping to the list coming in because this list */
    /* could contain GroupMember, EntityListItem, or EntityAdminListItem  */
    /* objects. The EntityListItem and EntityAdminListItem currently have */
    /* different cases for their properties, so we need to make sure to   */
    /* get the property by whatever case it is.                           */
    /*--------------------------------------------------------------------*/
    $utils.entityList = ($ctrl.entities || []).map(function (e) {
      var entity = {};

      entity.ID = e.ID || e.id || NaN;
      entity.Name = e.Name || e.name || null;
      entity.StudentID = e.StudentID || e.studentID || null;
      entity.Title = e.Title || e.title || null;
      entity.Display = e.Display || e.labelFunction || entity.Name;
      return entity;
    });

    /*---------------------------------------------*/
    /* Set up listener for the member delete event */
    /*---------------------------------------------*/
    $scope.$on(
      CommonUIGridTemplates.EVENT_DELETE_ROW,
      function (event, grid, row) {
        $utils.deleteMember(row.entity);
      }
    );

    /*--------------------------------------------*/
    /* Watch for when the members binding changes */
    /* to update the grid and nonMembers list     */
    /*--------------------------------------------*/
    $scope.$watch(
      function () {
        return $ctrl.members;
      },
      function () {
        if (!$ctrl.members) $ctrl.members = [];

        $ctrl.dgMembers.data = $ctrl.members;
        $utils.refreshNonMembers();
      }
    );
  };
}

/***************************************************************************
 * onNewMember */
/**
 * Blur handler for the New Member lazyTypeahead field. Clears the focus
 * indicator for the lazy typeahead as it does not dispatch blur events at
 * this time.
 ***************************************************************************/
/* @ngInject */ function onNewMember($ctrl, $timeout) {
  return function () {
    $ctrl.inputHasFocus = false;
  };
}

/***************************************************************************
 * refreshNonMembers */
/**
 * Filter the list of entities. Non members are entities not already in the
 * group.
 ***************************************************************************/
/* @ngInject */ function refreshNonMembers($ctrl, $utils) {
  return function () {
    $ctrl.nonMembers = $ctrl.members.length
      ? $utils.entityList.filter(function (ent) {
          return !$ctrl.members.some(function (gm) {
            return gm.ID == ent.ID;
          });
        })
      : $utils.entityList;
  };
}
